import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useAdminStatus = () => {
  return useQuery({
    queryKey: ['admin-status'],
    queryFn: async () => {
      // Use getSession (local check) instead of getUser (API call) to avoid
      // a DB round-trip on every page load for every anonymous visitor.
      const { data: { session } } = await supabase.auth.getSession();

      if (!session?.user) {
        return { isAdmin: false, user: null };
      }

      // Only query user_roles if we have an authenticated session
      const { data: userRoles, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', session.user.id)
        .eq('role', 'admin')
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Error checking admin status:', error);
        return { isAdmin: false, user: session.user };
      }

      return {
        isAdmin: !!userRoles,
        user: session.user
      };
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: false
  });
};